import routes from './routes';
import { SetRoutes } from 'components';

const ExtrastockOffersPages = () => {
  return (
    <>
      <SetRoutes routes={routes} />
    </>
  );
};

export default ExtrastockOffersPages;
